import { BlogPost } from '../../../types';
import { api } from '../../d1';

export class D1MiscRepo {
    // --- Blog ---
    async getBlogPosts(): Promise<BlogPost[]> {
        return [];
    }

    async getBlogPost(_id: number): Promise<BlogPost | undefined> {
        return undefined;
    }

    // --- Settings ---
    async getSetting(key: string): Promise<string | null> {
        try {
            return await api.settings.get(key);
        } catch (e) {
            console.error(`D1 getSetting error for ${key}`, e);
            return null;
        }
    }

    async setSetting(key: string, value: any): Promise<boolean> {
        try {
            const res = await api.settings.set(key, value);
            return !!res?.success;
        } catch (e) {
            console.error(`D1 setSetting error for ${key}`, e);
            return false;
        }
    }
}
